import { Component, Inject, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Paciente } from '../../pacientes/pacientes';
import {
  ArchivosAtencionService,
  ArchivoAtencion,
} from '../../../core/services/archivos-atencion.service';

@Component({
  selector: 'app-resumen-estudios-dialog',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, DatePipe],
  templateUrl: './resumen-estudios-dialog.html',
  styleUrl: './resumen-estudios-dialog.scss',
})
export class ResumenEstudiosDialog implements OnInit {
  analisis: ArchivoAtencion[] = [];
  cargando = false;

  constructor(
    private dialogRef: MatDialogRef<ResumenEstudiosDialog>,
    @Inject(MAT_DIALOG_DATA) public paciente: Paciente,
    private archivosAtencionService: ArchivosAtencionService,
  ) {}

  ngOnInit(): void {
    this.cargarAnalisis();
  }

  cerrar(): void {
    this.dialogRef.close();
  }

  cargarAnalisis(): void {
    if (!this.paciente.id) {
      return;
    }

    this.cargando = true;

    this.archivosAtencionService.obtenerArchivosPorPaciente(this.paciente.id).subscribe({
      next: (archivos: ArchivoAtencion[]) => {
        this.analisis = [...archivos].sort(
          (a, b) => new Date(b.fecha).getTime() - new Date(a.fecha).getTime(),
        );

        this.cargando = false;
      },
      error: () => {
        this.analisis = [];
        this.cargando = false;
      },
    });
  }

  obtenerFecha(fecha: string): string {
    if (!fecha) return '';

    const fechaDate = new Date(fecha);

    if (isNaN(fechaDate.getTime())) return '';

    return fechaDate.toLocaleDateString('es-MX', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'America/Mexico_City',
    });
  }

  descargarArchivo(analisis: ArchivoAtencion): void {
    this.archivosAtencionService.obtenerArchivo(analisis.id).subscribe({
      next: (blob: Blob) => {
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');

        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 60000);
      },
      error: (error) => {
        console.error('Error al descargar el archivo:', error);
      },
    });
  }
}
